<div *ngIf="isLoggedIn" class="icu-logo-align">
  <img src="assets/images/systartLogo.png" alt="logo" class="icu-logo-size">
</div>
<router-outlet></router-outlet>
<ng-container *transloco="let t">
  <div  *ngIf="isLoggedIn"  class="icu-menu-toggle-button  icu-vertical-stack-inline-items"  (click)="toggleLeftMenu()"
  [style.left]="leftMenuToggleClick ? '0px' : 'var(--icu-sidebar-width)'">
      <mat-icon class="material-symbols-outlined">menu</mat-icon>
  </div>
  <div *ngIf="isLoggedIn" class="icu-menu-button-container-left"
  [ngClass]="{'displayNone':(toggleStatus === true),'displayBlock':(toggleStatus === false)}">
    <div class="icu-menu-upper">
      <a [disabled]="menuDashboardDisabled" [routerLink]="['/dashboard']" class="icu-menu-item "
        routerLinkActive="icu-menu-active" mat-menu-item>
        <mat-icon class="icu-menu-icon ">dashboard</mat-icon>
        <div>
          <span class="icu-menu-name ">{{t('Home')}}</span>
        </div>
      </a>
      <a *ngIf="showUsers" [routerLink]="['/user-list']" class="icu-menu-list"
        routerLinkActive="icu-menu-active" mat-menu-item>
        <span class="icu-menu-name ">{{t('Users')}}</span>
      </a>
      <a *ngIf="showUsers" [routerLink]="['/role-list']" class="icu-menu-list"
        routerLinkActive="icu-menu-active" mat-menu-item>
        <span class="icu-menu-name ">{{t('Roles')}}</span>
      </a>
      <a *ngIf="showDevices" [routerLink]="['/device-list']" class="icu-menu-list"
        routerLinkActive="icu-menu-active" mat-menu-item>
        <span class="icu-menu-name ">{{t('Tracking Units')}}</span>
      </a>
      <a *ngIf="showJobs" [routerLink]="['/mission-list']" class="icu-menu-list"
        routerLinkActive="icu-menu-active" mat-menu-item id="icu-mission-menu">
        <span class="icu-menu-name ">{{t('Missions')}}</span>
      </a>
      <a *ngIf="showAlarms" [routerLink]="['/device-alarm-list']" class="icu-menu-list"
        routerLinkActive="icu-menu-active" mat-menu-item>
        <span class="icu-menu-name ">{{t('Alarms')}}</span>
      </a>
      <a *ngIf="showConfiguration" [routerLink]="['/system-config']" class="icu-menu-list"
        routerLinkActive="icu-menu-active" mat-menu-item id="icu-system-menu">
        <span class="icu-menu-name " >{{t('System')}}</span>
      </a>
    </div>
    <div class="icu-menu-lower">
      <a [routerLink]="['/user-profile']" class="icu-menu-profile icu-menu-hover"
        mat-menu-item>
        <mat-icon class="icu-menu-icon icu-menu-hover material-symbols-outlined">person</mat-icon>
        <span class="icu-menu-name icu-menu-label-hide">{{loggedUsername}}</span>
      </a>
      <button (mouseover)="showMenu()" (mouseleave)="leaveMenu()"
        class="icu-menu-item icu-menu-hover" mat-menu-item>
        <span>
          <mat-icon class="icu-menu-icon-expand icu-menu-hover">translate </mat-icon>
          <mat-icon class="icu-menu-arrow">arrow_right</mat-icon>
        </span>
        <span class="icu-menu-name icu-menu-label-hide">{{t('Language')}}</span>
      </button>
      <button (mouseover)="openLightMenu()" (mouseleave)="leaveLightMenu()"
       class="icu-menu-item icu-menu-hover" mat-menu-item>
        <span>
          <mat-icon class="icu-menu-icon-expand icu-menu-hover">settings_brightness</mat-icon>
          <mat-icon class="icu-menu-arrow">arrow_right</mat-icon>
        </span>
        <span class="icu-menu-name icu-menu-label-hide">{{t('Theme')}}</span>
      </button>
      <button (click)="onLogoutClick()" class="icu-menu-item icu-menu-hover" mat-menu-item>
        <mat-icon class="icu-menu-icon icu-menu-hover">logout</mat-icon>
        <span class="icu-menu-name icu-menu-label-hide">{{t('Logout')}}</span>
      </button>
      <span (mouseover)="showCalendar()" (mouseleave)="leaveCalendar()" class="icu-menu-utc-time icu-font-13 ">{{utcDate}}<br />{{utcTime | date :'HH:mm':'UTC'}} (UTC)</span>
    </div>
    <mat-menu></mat-menu>
  </div>
  <div class="icu-menu-button-container-left-popups">
    <div class="icu-calendar-class" *ngIf="showCalendars || onMouseOverCalendars" (mouseenter)="onMouseOverCalendar()" (mouseleave)="onMouseOutCalendar()">
      <hr class="icu-calendar-header-line">
      <div class="icu-week-header">
        <table>
          <tr>
            <td>Mo</td>
            <td>Tu</td>
            <td>We</td>
            <td>Th</td>
            <td>Fr</td>
            <td>Sa</td>
            <td>Su</td>
          </tr>
        </table>
      </div>
      <mat-calendar class="icu-calendar">
      </mat-calendar>
    </div>
    <div *ngIf="languageMenu || onMouseOverLanguageMenu" (mouseenter)="onMouseOverMenu()" (mouseleave)="onMouseOutMenu()"
    class="icu-menu-overlay-language">
      <button *ngFor="let language of supportedLanguages" (click)="onLanguageChanged(language)" mat-menu-item>
        <span class="icu-hover-popup">{{language.name}}</span>
      </button>
    </div>
    <div *ngIf="lightMenu || isMouseOverLightMenu" (mouseenter)="onMouseOverLightMenu()" (mouseleave)="onMouseOutLightMenu()"
    class="icu-menu-overlay-brightness">
      <button (click)="onChangeToDarkMode()" mat-menu-item class="icu-appearance-button">
        <mat-icon class="icu-hover-popup">dark_mode</mat-icon>
        <span class="icu-hover-popup">{{t('Dark')}}</span>
      </button>
      <button (click)="onChangeToLightMode()" mat-menu-item class="icu-appearance-button">
        <mat-icon class="icu-hover-popup">light_mode</mat-icon>
        <span class="icu-hover-popup">{{t('Light')}}</span>
      </button>
    </div>
  </div>
</ng-container>